import { HeroSection } from "./HeroSection";
import { FeatureCards } from "./FeatureCards";
import { EventCard } from "./EventCard";
// import { Gallery } from "./Gallery";
import { FirstBanner } from "./FirstBanner";
import { SecondBanner } from "./SecondBanner";
import { Testimonials } from "./Testimonials";
import { useEffect } from "react";
// import { FeaturedBrands } from "./FeatureBrands";

const LandingPage = () => {
  useEffect(() => {
    // Update canonical tag
    const canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://saddlefit.io/');
    }

    // Update meta tags and title
    document.title = 'Best Saddle Fitting Tool – 3D Scanner for Horses | SaddleFit.io';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Find the perfect saddle fit for your horse with SaddleFit.io\'s advanced 3D scanner. Ensure comfort and performance with precision technology.'
      );
    }
  }, []);

  return (
    <>
      <HeroSection />
      <FeatureCards />
      <EventCard />
      <FirstBanner type="LANDING" />
      <Testimonials />
      <SecondBanner type="LANDING" />
    </>
  );
};

export default LandingPage;
